import { ref } from '@vue/composition-api'
import { STORE_MODULE_NAME } from "./sectorStoreModule";

export default function useSector() {

    // Table Handlers
  const tableColumns = ref([
      { key: 'number',
        label: 'код',
      },
      { key: 'sector',
        label: 'название',
      },
      { key: 'station_from_code',
        label: 'начало',
      },
      { key: 'station_to_code',
        label: 'конец',
      },
      { key: 'length_km',
        label: 'длина',
      },
      { key: 'station_count',
        label: 'станций',
      },
      { key: 'railway',
        label: 'дорога',
      },
  ])

  const setupData = {
      formModel: {
          name:'',
          number: '',
          railway: '',
          user: ''
      },
  }

  const addDataUrl = `${STORE_MODULE_NAME}/create`
  const fetchDataUrl = `${STORE_MODULE_NAME}/fetch`

  return {

    addDataUrl,
    fetchDataUrl,

    tableColumns,
    setupData,
  }
}
